export { TextKey, getText } from './getText';
